<script>
import RetailerOffer from './retailer-offer'
import placeholderImg from '../../../../../src/assets/logo-placeholder.svg'

export default {
  name: 'OffersPreview',
  components: {
    RetailerOffer,
  },
  props: {
    retailer: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    offers: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    retailerImg() {
      return this.retailer.logo || placeholderImg
    },
  },
}
</script>

<template>
  <div :class="$style.offersPreview">
    <div :class="$style.leftSide">
      <div :class="$style.logoWrapper">
        <img
          :src="retailerImg"
          :alt="retailer.name"
        >
      </div>
      <a
        v-if="retailer.website"
        :href="retailer.website"
        target="_blank"
        rel="noopener"
        :class="$style.website"
      >
        <b>View Website</b>
      </a>
      <div :class="$style.description">
        {{ retailer.description }}
      </div>
    </div>

    <div :class="$style.rightSide">
      <div :class="$style.title">
        {{ retailer.name }}
      </div>

      <div
        v-for="(offer, index) in offers"
        :key="index"
      >
        <hr :class="['divider-primary', $style.divider]">
        <retailer-offer :offer="offer" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
  .divider {
    margin: 2rem 0;
  }

  .offersPreview {
    display: flex;
    width: 100%;
    line-height: 1.2rem;
  }

  .leftSide {
    max-width: rem(230px);
  }

  .rightSide {
    width: 100%;
    margin-left: rem(60px);
  }

  .logoWrapper {
    width: rem(230px);
    height: rem(230px);
    margin-bottom: rem(20px);
    overflow: hidden;
    border-radius: rem(10px);

    img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }

  .website {
    display: inline-block;
    margin-bottom: rem(20px);
    font-size: rem(13px);
    text-decoration: underline;
  }

  .description {
    font-size: rem(13px);
    line-height: 1rem;
  }

  .title {
    font-size: 1.4rem;
    font-weight: 600;
    line-height: rem(30px);
  }
</style>
